import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import reportsMeta from './reports-meta'
import SaveControls from './save-controls'
import permissions from 'scoreboard/components/permissions'
import reportHeader from './report-header'
import FormView from 'scoreboard/components/form-view'
import globals from 'scoreboard/components/globals'
import LoadingDots from 'scoreboard/components/loading-dots'
import loadingTemplate from './reports-overview-loading.hbs'
import layoutManager from 'scoreboard/components/layout-manager'

var ReportOverview = Backbone.View.extend({

	//this.model is a model of the current type of report being shown

	tagName: 'form',

	className: 'display-layout reports-overview table-hack',

	events: {
		'click .cancel': 'cancel'
	},

	initialize: function(options) {
		this.options = options

		let initialSort = _.get(options, 'state.sort')
		if (initialSort && initialSort.sortField) {
			// If restoring a previous sort state (bookmarks, briefings, exports),
			// apply that to the model before fetch and rendering
			this.model.setSort(initialSort)
		}

		let type = this.model.get('subtype')
		var meta = reportsMeta[type]
		var ResultView = meta.results
		this.results = new ResultView({
			model: this.model,
			parent: this,
			showQueryMetadata: true,
			isReport: true
		})
		this.header = reportHeader.generate('overview', this.model, this.results)
		this.controls = new SaveControls(_.defaults({
			model: this.model,
			error: function(model, response, options) {
				this.formView.error(response)
			}.bind(this)
		}, options || {}))

		var ReportForm = FormView.extend({
			test: this.controls.test.bind(this.controls)
		})

		this.formView = new ReportForm({
			primaryButtonEl: () => {
				return this.$('.button-primary.save')
			},
			el: this.el,
			submit: () => {
				return $.when(this.controls.submit()).then((state) => {
					//#17855 when cancelling from saving a new report, renabled
					//the save and guards
					this.formView.start()
					if (state == 'cancelFromNewSave') {
						//trigger change so the view is dirty for guarding
						this.formView.change()
					}
				})
			},
			allowCleanSubmission: this.controls.allowCleanSubmission.bind(this.controls)
		})
		// listen to any model changes and update the buttons accordingly
		this.listenTo(this.model, 'change', function(e) {
			this.formView.dirty = this.model.get('dirty')
			this.formView.valid = !this.controls.test()
			this.formView._updateButtons()
			this.controls.updateButtons()
		}.bind(this))

		this._subviews = [this.header, this.results]


		if (this._allowSaveControls()) {
			this._subviews.push(this.controls)
		}

		this.listenTo(this.header, 'change:period', _.debounce(this._updateResults.bind(this), 500))
		this.listenTo(this.controls, 'save-as-new', () => { this.formView.primaryButton.toggle(true) })
	},

	render: function() {
		this._clearPrevLoadingDots()
		this.$el.empty()
		_.each(this._subviews, function(v) {
			this.$el.append(v.el)
			v.render()
			this.on('resize', function() {v.trigger('resize')})
			v.delegateEvents()
		}.bind(this))

		//put the loading dots content right after the results view so it looks right
		this.results.$el.after(loadingTemplate())
		this.loadingDots && this.loadingDots.remove()
		this.loadingDots = new LoadingDots({el:this.$('.reports-overview-loading-dots-container')})
		this.listenTo(this.loadingDots, 'dots-rendered', () => {
			this.results.$el.toggleClass('is-not-displayed', true)
			this.$('.reports-overview-loading').removeClass('is-not-displayed')
		})

		if (this._allowSaveControls()) {
			this.formView.start()
			//if we're showing the save controls on the overview, the form is dirty
			//and should be guarded against
			if (this.controls.allowCleanSubmission()) {
				this.formView.change()
			}

			// If save controls are present, check to see if the button-toolbar only
			// has a single button. If so, add a class indicating that so we can
			// style it correctly.
			let displayedButtons =
				this.$('.button-toolbar').children(':not(.is-not-displayed)')
			let onlyChild = displayedButtons.length === 1
			this.$('.button-toolbar li').toggleClass('only-child', onlyChild)
		}
		this.secure()

		if (!layoutManager.export) {
			// If we're doing an export the view is not ready until all results
			// are rendered, but for a normal user the view is ready now.  Trigger
			// this here so start.js receives the appDisplay.js:'render:display' event
			this.trigger('ready')
		}

		return this
	},

	_allowSaveControls() {
		// If we're in a bookmark/briefing, we don't want any of the save controls.
		// Easiest way to accomplish that is to just not render SaveControls
		// https://github.com/SpiderStrategies/Scoreboard/issues/24709#issuecomment-508232644
		// however #27796 we need to show the mass edit button
		// NOTE: with #27617, mass edit is moved to the admin section. The mass
		// edit button was removed from save-controls and is not viewable in the
		// reports section OR briefing section.
		// #9287 we also want to hide save controls if no permission to modify reports
		return permissions.reports(globals.orgId)
	},

	_clearPrevLoadingDots () {
		this.loadingDots && this.loadingDots.clear()
		this.results.$el.toggleClass('is-not-displayed', false)
		this.$(`.reports-overview-loading`).addClass('is-not-displayed')
	},

	_updateResults: function() {
		//the report has built in handling of period changes
		if (this.model.designer) {
			this.model.set('relativePeriodId', globals.periodId)
			return
		}
		this.$('.banner-update-results')
			.addClass('is-not-displayed')
		this.loadingDots.render()

		var debouncedPeriodId = globals.periodId
		this.model.fetch().then(function() {
			if (this.model.get('subtype') == 'chart-writer') {
				this._clearPrevLoadingDots()
				//#16032 make chart updates in-place
				this.results.render()
			} else {
				// the period might have changed between the when the model
				// fetched the results, to when we recieved the signal that
				// results were ready for rendering.  If so ignore this batch
				// and re-render only when the periods match (i.e no changes
				// happened during the interim fetch)
				if (debouncedPeriodId == globals.periodId) {
					this.render()
				}
			}
		}.bind(this))
	},

	secure: function() {
		this.header.conditionallyHideEditTab(this.model.isEditable())
	},

	cancel: function(e) {
		this.controls.cancel(e)
	},

	/**
	 * This view is what export-preparer sees when a scheduled excel export is
	 * being generated, but the exportTable is on the results view, so we must
	 * delegate to it here. (24033)
	 */
	exportTable() {
		return this.results.exportTable(this.model.get('label'))
	},

	/**
	 * @param {Boolean} [options.export] pass true if the state is to recreate an export
	 */
	getState: function (options = {}) {
		return this.results.getState(options)
	},

	/**
	 * Handles pre-removal actions.  In this case for designers stops the table
	 * model from listening from consuming any more data emitting from the designer
	 * model since the view this table model belongs will be removed
	 */
	prepareRemove: function() {
		_.invoke(this.results.tableModel, 'remove')
		_.invokeMap(this._subviews, 'remove')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, this.arguments)
		_.invokeMap(this._subviews.concat([this.formView, this.loadingDots]), 'remove')
	}
})


ReportOverview.loadOptions = {
	results: true
}

export default ReportOverview

ReportOverview.__filename__ = 'reports/reports-overview.js'
